<!-- so why these ng-containers with ngSwitch and ngFor of keys? Because: -->
<!--"Never spend 6 minutes doing something by hand when you can spend 6 hours failing to automate it"-->
<div class="projects-table-wrapper" [ngClass]="{ manager: user.isPaidAccount, contractor: !user.isServiceProvider }">
  <div class="grid-table">
    <div class="grid-row header-row">
      @for (header of headers; track header; let i = $index) {
        @switch (header.key) {
          @case ('attributes') {
            <div class="item attributes">
              <div class="inner-container">
                <span class="select-label">{{ header.name }}</span>
                <mat-form-field class="input no-preview">
                  <mat-select multiple [formControl]="attributesControl">
                    <mat-option [value]="'all'">Show All</mat-option>
                    @for (atr of PROJECT_ATTRIBUTES; track atr) {
                      <mat-option [value]="atr.id">{{ atr.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
          @case ('statusId') {
            <div class="item status">
              <div class="inner-container">
                <span class="select-label">{{ header.name }}</span>
                <mat-form-field class="input no-preview no-preview borderless">
                  <mat-select multiple [formControl]="statusControl">
                    @for (status of allStatuses; track status) {
                      <mat-option [value]="status.id">{{ status.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
          @case ('complete') {
            <div
              matTooltipPosition="below"
              matTooltip="{{ viewType === VIEWS.MANAGER ? header.tooltip : header.tooltipContractor }}"
              (click)="sortBy(i)"
              class="item header-{{ header.key }}"
            >
              <div class="inner-container">
                <span>
                  {{ header.name }}
                </span>
                <app-sort-arrow [hide]="lastSortedBy !== i" [isDesc]="!lastSortedAscending[i]"></app-sort-arrow>
              </div>
            </div>
          }
          @default {
            <div
              matTooltipPosition="below"
              matTooltip="{{ header.tooltip }}"
              (click)="sortBy(i)"
              class="item header-{{ header.key }}"
            >
              <div class="inner-container">
                <span>
                  {{ header.name }}
                </span>
                <app-sort-arrow [hide]="lastSortedBy !== i" [isDesc]="!lastSortedAscending[i]"></app-sort-arrow>
              </div>
            </div>
          }
        }
      }
    </div>
  </div>

  @if (tableData.length === 0 && !isLoading) {
    <div class="error-msg">No Projects.</div>
  }
  @if (tableData.length === 0 && isLoading) {
    <div class="flex w-full h-full items-center justify-center">
      <div class="notify-msg animate-pulsating-border">
        <div class="icon-logo-box-hex"></div>
      </div>
    </div>
  }

  <ng-scrollbar appearance="compact" orientation="vertical" class="std-scrollbar">
    <div class="grid-table">
      @for (project of tableData; track project) {
        <div class="grid-row project-row">
          @for (key of dataKeys; track key) {
            @switch (key) {
              <!--          this ngSwitch thing is genius-->
              @case ('title') {
                <div (click)="navigateToProject(project.id, project.status)" class="item title">
                  <div>{{ project.title }}</div>
                  <div class="address">{{ project.project_property?.formatted_address }}</div>
                </div>
              }
              @case ('complete') {
                <div class="item">
                  <app-progress-bar [percent]="project.complete"></app-progress-bar>
                </div>
              }
              @case ('attributes') {
                <div class="item attributes">
                  <span [ngClass]="{ inactive: !project.attributes.capex }" class="icon-capex"></span>
                  <span [ngClass]="{ inactive: !project.attributes.opex }" class="icon-opex"></span>
                  <span
                    [ngClass]="{ inactive: !project.attributes.priority }"
                    class="icon-attention icon-priority"
                  ></span>
                  <span
                    [ngClass]="{ inactive: !project.attributes.contracts_approved }"
                    class="icon-checkbox-round icon-approved"
                  ></span>
                </div>
              }
              @case ('start_date') {
                <div class="item">
                  {{ project[key] | datepipe: UTC_DATE }}
                </div>
              }
              @case ('statusId') {
                <div class="item status">
                  <app-project-bubble
                    (resetData)="updateProjectStatus($event)"
                    [project]="project"
                    [isDropDown]="true"
                    [center]="false"
                    [allStatuses]="allStatuses"
                  ></app-project-bubble>
                </div>
              }
              @case ('approved') {
                <div [matTooltip]="project[key] ? 'Approved' : 'Pending'" class="item approved">
                  @if (project[key] === true) {
                    <span class="icon-approved"></span>
                  }
                  @if (project[key] === false) {
                    <span class="icon-attention"></span>
                  }
                </div>
              }
              @default {
                @switch (isNumber(project[key])) {
                  @case (true) {
                    <div class="item" [ngClass]="{ negative: project[key] < 0 }">
                      <span
                        [matTooltipClass]="{ 'negative-tooltip': project[key] < 0 }"
                        [matTooltip]="project[key] !== 0 ? (project[key] | money: 'positiveComa') : '$ 0'"
                      >
                        {{ project[key] | money: 'shortSimpleSpace' }}
                      </span>
                    </div>
                  }
                  @case (false) {
                    <div class="item">
                      {{ project[key] }}
                    </div>
                  }
                }
              }
            }
          }
        </div>
      }
    </div>
  </ng-scrollbar>
  @if (showTotals) {
    <div class="grid-table totals">
      <div class="grid-row">
        <div class="item">Totals</div>
        <div class="item">{{ totals.numberOfProjects }} projects</div>
        <div [ngClass]="{ invisible: viewType === VIEWS.CONTRACTOR }">
          <span
            [matTooltipClass]="{ 'negative-tooltip': totals.current_budget < 0 }"
            [matTooltip]="totals.current_budget | money: 'positiveComa'"
            [ngClass]="{ negative: totals.current_budget < 0 }"
            class="item"
          >
            {{ totals.current_budget | money: 'shortSimpleSpace' }}
          </span>
        </div>
        <div [ngClass]="{ invisible: viewType === VIEWS.CONTRACTOR }">
          <span
            [matTooltipClass]="{ 'negative-tooltip': totals.total_committed < 0 }"
            [matTooltip]="totals.total_committed | money: 'positiveComa'"
            [ngClass]="{ negative: totals.total_committed < 0 }"
            class="item"
          >
            {{ totals.total_committed | money: 'shortSimpleSpace' }}
          </span>
        </div>
        <div>
          @if (viewType === VIEWS.MANAGER) {
            <span
              [matTooltipClass]="{ 'negative-tooltip': totals.forecasts_to_complete < 0 }"
              [matTooltip]="totals.forecasts_to_complete | money: 'positiveComa'"
              [ngClass]="{ negative: totals.forecasts_to_complete < 0 }"
              class="item"
            >
              {{ totals.forecasts_to_complete | money: 'shortSimpleSpace' }}
            </span>
          }
          @if (viewType === VIEWS.CONTRACTOR) {
            <span
              [matTooltipClass]="{ 'negative-tooltip': totals.proposal_sum < 0 }"
              [matTooltip]="totals.proposal_sum | money: 'positiveComa'"
              [ngClass]="{ negative: totals.proposal_sum < 0 }"
              class="item"
            >
              {{ totals.proposal_sum | money: 'shortSimpleSpace' }}
            </span>
          }
        </div>
        <div>
          @if (viewType === VIEWS.MANAGER) {
            <span
              [matTooltipClass]="{ 'negative-tooltip': totals.actuals < 0 }"
              [matTooltip]="totals.actuals | money: 'positiveComa'"
              [ngClass]="{ negative: totals.actuals < 0 }"
              class="item"
            >
              {{ totals.actuals | money: 'shortSimpleSpace' }}
            </span>
          }
          @if (viewType === VIEWS.CONTRACTOR) {
            <span
              [matTooltipClass]="{ 'negative-tooltip': totals.total_committed < 0 }"
              [matTooltip]="totals.total_committed | money: 'positiveComa'"
              [ngClass]="{ negative: totals.total_committed < 0 }"
              class="item"
            >
              {{ totals.total_committed | money: 'shortSimpleSpace' }}
            </span>
          }
        </div>
        @if (viewType === VIEWS.CONTRACTOR) {
          <div>
            <span
              [matTooltipClass]="{ 'negative-tooltip': totals.actuals < 0 }"
              [matTooltip]="totals.actuals | money: 'positiveComa'"
              [ngClass]="{ negative: totals.actuals < 0 }"
              class="item"
            >
              {{ totals.actuals | money: 'shortSimpleSpace' }}
            </span>
          </div>
        }
        <div class="item">
          <app-progress-bar [percent]="totals.complete"></app-progress-bar>
        </div>
      </div>
    </div>
  }
</div>
